import CommunityRating from '@sly/frontend/react/shared/components/CommunityRating';
import { ProviderIndexCardProps } from 'sly/providerIndex/ProviderIndex.types';
import Link from 'sly/system/Link';

export default function ProviderIndexCard({
  heading,
  communityCount,
  reviewsValue,
  numReviews,
  url,
}: ProviderIndexCardProps) {
  return (
    <Link to={url} className='hover:no-underline'>
      <div className='border-viridian-lighter-400 w-fit'>
        <div className='flex flex-col text-slate-base'>
          <div className='flex flex-row'>
            <span className='font-t-s mr-3 break-all align-text-top text-xl leading-[28px]'>
              <p className='mr-2 text-viridian-base'>{heading}</p>
              <p className='font-b-m h-[24px] whitespace-nowrap align-baseline'>{`${communityCount} communities`}</p>
            </span>
          </div>
          {numReviews ? (
            <CommunityRating
              rating={reviewsValue}
              numReviews={numReviews}
              seedId={heading}
              reviewsText
              wrapperClassName='text-slate-base'
            />
          ) : (
            <CommunityRating
              rating={0}
              numReviews={0}
              seedId={heading}
              showNotYetRatedText
              wrapperClassName='text-slate-base'
            />
          )}
        </div>
      </div>
    </Link>
  );
}
